export const UPLOADMESSAGES = {
  DEFAULT_PERMISSION_TITLE:
    "Please note the default permissions will be given to the roles you belong to.",
  RESOURCE_CREATION_ERROR: "Unable to create folder/file. Please contact administrator.",
  FOLDER_PUBLISH_CONFIRM: "Do you want to publish this folder ?",
  FILE_PUBLISH_CONFIRM: "Do you want to publish this file ?",
  FILE_PUBLISH_TITLE: "Publish File",
  FOLDER_PUBLISH_TITLE: "Publish Folder",
};

export const UPLOADVALIDATIONS = {
  PERMISSION_VALIDATION: "At least one permission must be checked.",
  FOLDERFILEBOTH_VALIDATION:
    "Only one action is allowed at a time. Kindly choose either to create a folder or upload a file.",
  FOLDERFILEEMPTY_VALIDATION: "Please either enter a folder name or upload a file to proceed.",
  FOLDER_WHITESPACE_VALIDATION: "Please enter a valid folder name or choose a file to upload.",
  FOLDEREMPTY_VALIDATION: "Please enter name",
  FILEEMPTY_VALIDATION: "File name cannot be empty",
  FOLDER_SPEC_CHAR_VALIDATION:
    "A file name can't contain any of the following characters: {Invalid Chars}",
  FILE_MAX_SIZE: "File size must be {attachmentSize} MB or less.",
  FOLDER_ALREADY_EXISTS: "Folder name already exits",
  FILE_ALREADY_EXISTS: "File name already exits",
};

export const RECYCLEMESSAGES = {
  RESTORE_SUCCESSFUL: "Restore successful",
  RESTORE_FAILED: "Restore failed",
  REPLACESKIP_TITLE: "Replace or Skip Files",
  SINGLE_SKIP: "Skip this file",
  MULTIPLE_SKIP: "Skip these files",
  SINGLE_REPLACE: "Replace the file in the destination",
  MULTIPLE_REPLACE: "Replace the files in the destination",
  FILE_REPLACE: "Replace the file in the destination",
  FOLDER_REPLACE: "Replace the files in the destination",
  FILE_SKIP: "Skip this file",
  FOLDER_SKIP: "Skip this folder",
};

export const GLOBALMESSAGES = {
  GLOBAL_ERROR: "An unexpected error occurred. Please contact administrator.",
  NETWORK_ERROR: "Network connection lost. Please check your connection and try again.",
  FAILED_ADDITION: " Failed",
  Close: "close",
  Home: "Home",
  Retrieved: "Retrieved",
  BOTH_DATES: "Both dates are required",
  TO_DATE_GREATER: "Date To cannot be earlier than Date From",
  NOROWSTEXT: "No data found",
  EMPTY_FOLDER: "The folder is empty",
  GENERAL: "General",
  UNTITLED: "Untitled",
  BACKDROP: "backdropClick",
  NOT_AUTHORIZED:
    "You don’t have permission to view this page. Please contact the administrator to enable access.",
  WELCOME_BACK: "Welcome back!",
  WELCOME: "Welcome!",
};

export const INTERNALMESSAGES = {
  TO_REQUIRED: "Recipient is required",  
  USERS_REQUIRED: "Please select at least one user",
  HELP: "Help & Support",
  SUBJECT_REQUIRED: "Please enter a subject.",
  BODY_REQUIRED: "Please enter a message.",
  MESSAGES: "Messages",
  NOTIFICATIONS: "Notifications",
  MARK_READ: "Mark as read",
  MARK_UNREAD: "Mark as unread",
  INVALID_EXTENSIONS: "Invalid File Type, please try again",
  REASSIGN_SUCCESS: "Reassigned the user successfully",
  REASSIGN_FAIL: "Reassigning to user failed",
  RECALL_SUCCESS: "Message recalled successfully",
  RECALL_FAIL: "Recalled the user failed",
  SELECT_REASSIGN_USER: "Please select a user to reassign.",
  RECALL_CONFIRM: "Do you want to recall this message?",
  BODY_MIN_LENGTH: "Message body must be at least 10 characters",
};

export const EDITRESOURCEMESSAGES = {
  EDIT_FOLDER: "Edit Folder / File",
  PUBLISH_FOLDER: "Publish Folder / File",
  UPDATE: "Update",
  PUBLISH: "Publish",
  CANCEL: "Cancel",
  NO_UPDATE: "You haven’t changed anything to update",
};

export const LABELNAMES = {
  FILE_EXPLORER: "File Explorer",
  COMMUNICATION: "Communication",
  PROFILE: "Profile",
};

export const FOLDERTREEMESSAGES = {
  ROOT_FOLDER: "All Files/Folders",
  DRAG_TYPE: "FOLDER",
};

export const MANAGESETTINGS = {
  SETTING_UPDATE_SUCCESS: "Setting updated successfully",
  DESCRIPTION_EMPTY: "Description cannot be empty",
  VALID_NUMBER: "Please enter a valid number",
  VALID_JSON: "Please enter valid JSON",
  VALID_OPTION: "Please select a valid option",
  FIELD_EMPTY: "This field cannot be empty",
  FILE_NAME: "SettingsData",
  PRINT_COLUMN_HIDE: "defaultValue",
  EXPORT: "Export",
  EXPORT_CSV: "Export as CSV",
  PRINT: "Print",
  EXPORT_PRINT: "Export as PDF",
};

export const DUPLICATEVALIDATIONS = {
  DUPLICATE_FOLDER_SUCCESS: "Folder cloned successfully",
  DUPLICATE_FILE_SUCCESS: "File cloned successfully",
};

export const DOWNLOADVALIDATIONS = {
  DOWNLOAD_CANCEL: "Download canceled by the user.",
  DOWNLOAD_ERROR: "An unexpected error occurred while downloading. Please try again.",
  USER_CANCEL: " UserCancelled",
  CANCEL_DOWNLOAD_CONFIRMATION:
    "Your download is not complete. Would you like to cancel the download?",
};

export const SHARERESOURCEVALIDATIONS = {
  USERS_NOPERMISSION:
    "Sorry, the selected user(s) listed below will not be able to access this content, as they don’t have the required permissions.",
  ROLES_NOPERMISSION:
    "Sorry, the selected roles(s) listed below will not be able to access this content, as they don’t have the required permissions.",
  REMOVE_NAMES: "Kindly remove the highlighted role(s) to proceed.",
  REMOVE_USERS: "Kindly remove the highlighted user(s) to proceed.",
  NO_ROLES_FOUND: "No roles found",
  NO_USERS_FOUND: "No users found",
  NO_SELECTION: "Kindly select either Share link or Attach as copy",
  SELECT_ROLES: "Please select at least one role",
  SELECT_USERS: "Please select at least one user",
  ROLE_PATH: "shareRole=true",
  USER_PATH: "shareUser=true",
};

export const ACTIONITEMVALIDATIONS = {
  DELETE_RESOURCE: "Are you sure you want to delete this item?",
  UNPUBLISH_RESOURCE: "Are you sure you want to unpublish this item?",
  CONFIRM: "Confirm",
  READONLY_ACCESS: "You have only read access",
};

export const CONTACTPAGEVALIDATIONS = {
  EMPLOYEE_RESOURCE: "Are you an employee?",
  HR_REACH: "Redirecting you to the Careers page for further assistance",
  HAMASPIK_CAREERS: "https://www.hamaspikkings.org/careers",
  CAPTCHA_FAILED: "CAPTCHA verification failed. Please try again.",
};
export const INSTRUCTION_TEXT = (mappedTo: string) =>
  `Note: Clicking the Send button will send your details to ${mappedTo}.`;
export const ISSUE_SENT = (mappedTo: string) =>
  `Thank you! An email has been sent to ${mappedTo}. The HR team will reach you soon.`;
export const ISSUE_SENT_FAIL = (mappedTo: string) =>
  `Sorry, sending email to ${mappedTo} failed.`;
export const SETTING_CHANGED = (settingName: string, userName: string) =>
  `The setting value for ${settingName} has been recently changed by ${userName}`;
export const ZERO_FILE_SIZE = (name: string) => `The file ${name} is empty and cannot be uploaded`;
export const DESCRIPTION_LENGTH = (type: string, length: number) =>
  `Sorry, ${type} name cannot exceed ${length} characters.`;
export const UPDATE_DETAILS = (name: string) => `Updated ${name} details successfully`;

export const FILE_CREATED_SUCCESS = (name: string) => `File ${name} created successfully`;
export const FOLDER_CREATED_SUCCESS = (name: string) => `Folder ${name} created successfully`;
export const FOLDER_PUBLISHED_SUCCESS = (name: string) => `Folder ${name} published successfully`;
export const FILE_PUBLISHED_SUCCESS = (name: string) => `File ${name} published successfully`;
export const ALLOWED_FILE_SIZE = (size: number) =>
  `The selected file is too large. Maximum allowed file size is ${size}`;
export const ALLOWED_FILE_LIMIT = (count: number) =>
  `You’ve reached the limit of {${count}} attachments. Please remove one to add a new file.`;

export const SHARE_SUCCESSFUL = (type: string, name: string) =>
  `${type} ${name} Shared successfully`;
export const SHARE_FAIL = (type: string, name: string) => `${type} ${name} Sharing failed`;
export const DELETE_SUCCESSFUL = (value: string) => `Deleted ${value} successfully`;
export const DELETE_FAIL = (value: string) => `Deletion for ${value} failed`;
export const UNPUBLISH_SUCCESSFUL = () => `The item has been successfully unpublished`;
export const UNPUBLISH_FAIL = (value: string) => `UnPublish for ${value} failed`;

export const MESSAGE_SENT = () => `Message sent successfully`;
export const MESSAGE_FAIL = (value: string) => `Message sent to ${value} failed`;

export const MESSAGEREAD_FAIL = (checked: boolean) =>
  `Mark ${checked === true ? "read" : "unread"} failed`;

export const NO_ACCESS = (name: string) => `You no longer have permission to access ${name}`;

export const MOVEFOLDER_SUCCESSFUL = (oldName: string, newName: string) => {
  if (!oldName || !newName) return "Folder moved successfully";
  return `Folder moved from ${oldName} to ${newName} successfully`;
};
export const MOVEFILE_SUCCESSFUL = (value: string) => `File Moved To  ${value} Successfully`;
export const MOVEFOLDER_SAMELOCATION = (folderName: string) =>
  `The folder "${folderName}" already exists in the selected location.`;
export const TARGETFOLDER_DONT_HAVE_PERMISSION = (folderName: string) =>
  `Move failed, Insufficient permissions on destination folder - "${folderName}"`;
export const SINGLE_FILE_EXISTS = (fileName: string) =>
  `The destination already has a file named ${fileName}`;
export const MULTIPLE_FILE_EXISTS = (fileCount: number) =>
  `The destination has ${fileCount} files with the same names`;
export const SINGLE_FOLDER_EXISTS = (folderName: string) =>
  `The destination already has a folder named ${folderName}`;

export const IMPERSONATE_SUCCESSFUL = (
  impersonatorUserName: string,
  targetUserName: string,
  date: string
) => `${impersonatorUserName} Impersonated ${targetUserName} on ${date}`;
export const IMPERSONATE_FAIL = (userName: string) => `Sorry, Impersonation for ${userName} failed`;
export const EXITIMPERSONATE_FAIL = (userName: string) =>
  `Sorry, Exit Impersonation for ${userName} failed`;
export const EXITIMPERSONATE_SUCCESSFUL = (userName: string) =>
  `You are no longer impersonating ${userName}. Welcome back to your account.`;

export const GetTooltipMessages = (type: string) => ({
  Download: `Download this ${type}`,
  MakeACopy: `Clone this ${type}`,
  AddNew: `Create new folder/file`,
  Edit: `Edit this ${type} name`,
  Publish: `Publish this ${type}`,
  UndoPublish: `Unpublish this ${type}`,
  ShareToRole: `Share this ${type} to roles`,
  ShareToUser: `Share this ${type} to users`,
  MoveToBin: `Delete this ${type}`,
});

export const GetTraceMessages = (type: string, description: string, failed: boolean) => ({
  Download: failed
    ? `Failed to download ${type} - ${description}`
    : `${type} - ${description} downloaded`,
  MakeACopy: failed
    ? `Failed to clone ${type} - ${description}`
    : `${type} - ${description} cloned`,
  AddNew: failed
    ? `Failed to create new ${type} - ${description}`
    : `New ${type} - ${description} created`,
  Edit: failed ? `Failed to edit ${type} - ${description}` : `${type} - ${description} edited`,
  Publish: failed
    ? `Failed to publish ${type} - ${description}`
    : `${type} - ${description} published`,
  UndoPublish: failed
    ? `Failed to UnPublish ${type} - ${description}`
    : `${type} - ${description} UnPublished`,
  ShareToRole: failed
    ? `Failed to share ${type} - ${description} to roles`
    : `${type} - ${description} shared to roles`,
  ShareToUser: failed
    ? `Failed to share ${type} - ${description} to users`
    : `${type} - ${description} shared to users`,
  MoveToBin: failed
    ? `Failed to delete ${type} - ${description}`
    : `${type} - ${description} deleted`,
  RESTORE: failed
    ? `Failed to restore ${type} - ${description}`
    : `${type} - ${description} restored`,
  UNLOCKUSER: failed ? `Failed to unlock User - ${description}` : `User - ${description} unlocked`,
  LOCKUSER: failed ? `Failed to lock User - ${description}` : `User - ${description} locked`,
  UNLOCKSESSION: failed
    ? `Failed to unlock Session - ${description}`
    : `Session - ${description} unlocked session`,
  LOCKSESSION: failed
    ? `Failed to lock Session - ${description}`
    : `Session - ${description} locked session`,
});

export const ActionMappings: Record<string, keyof ReturnType<typeof GetTraceMessages>> = {
  Download: "Download",
  "Add new": "AddNew",
  Edit: "Edit",
  Publish: "Publish",
  "Undo publish": "UndoPublish",
  "Share to roles": "ShareToRole",
  "Share to users": "ShareToUser",
  "Make a copy": "MakeACopy",
  Delete: "MoveToBin",
  Restore: "RESTORE",
  "Unlock User": "UNLOCKUSER",
  "Lock User": "LOCKUSER",
  "Unlock Session": "UNLOCKSESSION",
  "Lock Session": "LOCKSESSION",
};

export const DefaultTrace = (action: string, name: string) => `Performed '${action}' on ${name}`;

export const USERSIGNUPMESSAGES = {
  FILL_OUT_EMAIL_OR_PHONE: "Enter an Email or Phone.",
  ENTER_VALID_PHONE_NUMBER: "Please enter a valid Phone.",
  ENTER_VALID_EMAIL_ADDRESS: "Please enter a valid Email address.",
  ENTER_VALID_EMAIL_OR_PHONE: "Please enter valid Email or Phone",
  PASSWORD_IS_REQUIRED: "Password is required",
  CONFIRM_PASSWORD_IS_REQUIRED: "Confirm Password is required",
  PASSWORD_MUST_LEAST_8_CHAR: "Password must be at least 8 characters long.",
  PASSWORD_DO_NOT_MATCH: "Sorry, Passwords do not match",
  OTP_CODE_REQUIRED: "Please enter the OTP you’ve just received.",
  OTP_CODE_6_DIGIT_NUMBER: "Please enter the 6-digit code sent to your",
  OTP_CODE_DOES_NOT_MATCH: "Invalid OTP. Kindly check and enter the correct code.",
  OTP_CODE_EXPIRED: "The OTP has expired. Please click on 'Resend OTP' to receive a new one.",
  AUTHENTICATION_CODE_REQUIRED: "Please enter authentication code.",
  AUTHENTICATION_CODE_6_DIGIT_NUMBER:
    "Invalid code. Ensure the authentication code is a 6-digit number.",
  AUTHENTICATION_CODE_DOES_NOT_MATCH:
    "The code you provided does not match. Please ensure you are using the latest code from your authenticator app.",
  EMAIL_PHONE_DOES_NOT_EXIST:
    "Sorry this Email ID/Phone does not exist, please contact the HR Coordinator.",
  USERNAME_CAN_ONLY_CONTAIN: "Username can only contain letters, numbers, dot and underscores.",
  EMAIL_ALREADY_TAKEN: "Sorry this email has been already taken, please try another.",
  USERNAME_ALREADY_TAKEN: "Sorry this Username has been already taken, please try another.",
  PLEASE_VERIFY_OTP: "Please verify OTP",
  PLEASE_VERIFY_2FA: "Please verify 2FA verification",
  VALIDATION_PASSWORD_OR_2FA: "Please enter password or verify 2FA verification",
  VALIDATION_PASSWORD_OR_OTP: "Please enter password or verify OTP",
  VALIDATION_PASSWORD_AND_2FA: "Please enter password and verify 2FA verification",
  VALIDATION_PASSWORD_AND_OTP: "Please enter password and verify OTP",
  SAVE_AND_ROLE_MESSAGE: "Congrats!! You have successfully signed up.",
  OTP_VERIFIED_MESSAGE:
    "Your OTP has been verified successfully. You can now proceed to the next step.",
  MANUAL_CODE_COPIED: "Copied!",
  USERFIRSTNAME_IS_REQUIRED: "Please fill out the First Name.",
  USERLASTNAME_IS_REQUIRED: "Please fill out the Last Name.",
  IssueType_IS_REQUIRED: "Please select type of Issue",
  ISSUE_DESCRIPTION_IS_REQUIRED: "Please fill out the Issue Description.",
  REQUESTFORMSUCCESSMESSAGE:
    "Thank you! An email has been sent to HR@hamaspikkings.org. The HR team will reach you soon.",
  INSTRUCTIONTEXT: "Note: Clicking the Send button will send your details to HR@hamaspikkings.org.",
  FILL_OUT_EMAIL: "Please fill out Email.",
  FILL_OUT_PHONE: "Please fill out Phone.",
  NOT_HAVE_ROLE_ASSIGNED: "Sorry, you do not have roles assigned. Please reach out to HR.",
  ROLE_NOT_MAPPED:
    "User registered successfully, however, your employement history is not active, kindly contact HR",
  USER_ALREADY_REGISTERED: "You’re already registered. Please log in to continue.",
  AUTH_APP_IS_SETUP:
    "Please ensure the authenticator app is set up before proceeding. If not, return to the previous step to complete the setup.",
  ALREADY_REGISTERED:
    "Looks like you are already registered with us. Please sign in or use 'Forgot Password'.",
};

export const ERRORMESSAGES = {
  APIErrorLogging: "Error logging to API",
  UNHANDLEDEXCEPTION: "Error occurred at onunhandledrejection",
};

export const POPOVERMESSAGES = {
  SIGNUP:
    "<p>Creating an account is quick and easy!<br> Here’s what you need to do:</p>" +
    "<ul>" +
    "<li><b>Enter Your Details:</b> Provide your Email<br> or Phone and a password.</li>" +
    "<li><b>Complete Your Profile:</b> Add any<br> additional details to personalize your<br> experience.</li>" +
    "</ul>",
  DO_NOT_SET_ONE: "<h6>Do not set one</h6><p>clear the Username textbox.</p>",
  SIGNUP_WITH_OTP:
    "<h6>Sign up with OTP</h6>" +
    "Enter the 6-digit OTP sent to your registered phone/email.<br>" +
    "OTP is valid for 5 minutes.<br>" +
    "If you didn’t receive the OTP, try resending after 30 seconds.<br>",
  SIGNIP_WITH_PASSWORD:
    "<h6>Set yourself up with a Password</h6>" +
    "<b>Use a Mix of Characters:</b> Include uppercase letters, lowercase letters, numbers, and special characters.<br>",
  SIGNUP_WITH_2FA:
    "<h6>Secure Your Account with 2FA</h6>" +
    "<b>Download a 2FA app</b> if you don’t have one.<br>" +
    "<b>Scan the QR code</b> (or manually enter the provided key).<br>" +
    "<b>Enter the generated code</b> from your app to verify.<br>",
  HelpTooltip: "Help",
};

export const USERSIGNINMESSAGES = {
  USERINPUT_REQUIRED: "Enter an Email or Phone or Username",
  USERINPUT_INVALID: "Please enter a valid Email or Phone or Username",
  USER_NOT_REGISTERED: "The Email or Phone or Username you entered is not registered.",
  PASSWORD_REQUIRED:
    "Enter your password, or set one up by clicking the 'Reset/Forgot your password' link if you haven’t already.",
  USERINPUT_VALID: "We couldn’t find your account. Please sign up to get started.",
  // eslint-disable-next-line no-template-curly-in-string
  PASSWORD_REQUIRED_MIN_CHAR: "Password must be at least ${passwordMinLength} characters long.",
  INCORRECT_PASSWORD_MESSAGE: "Sorry Incorrect password, please try again.",
  IP_NOT_WHITELISTED: "Login denied, sorry your IP address is not whitelisted.",
  FORGOTPASSWORD_HEADER_TEXT:
    "Enter your Email, Phone, or Username. On clicking 'Next', we will send you a code to confirm your identity.",
  FORGOTPASSWORD_SENT_VERIFICATION_MESSAGE:
    "We've sent a verificaiton code to your {Phone_Email} - {Phone_Email_value}",
  PASSWORD_RESET_MESSAGE:
    " Your password has been successfully reset. You can now log in with your new password.",
    PROFILE_UPDATE_SUCCESS: "Profile updated successfully",
  SESSION_LOCKED_MESSAGE:
    "Too many failed attempts, your session({Session_value}) has been locked, please try again later or contact HR Coordinator",
  ACCOUNT_LOCKED_MESSAGE:
    "Your account has been locked for security reasons. Please contact the HR coordinator.",
  ACCOUNT_EXPIRED_MESSAGE:
    "Your account is no longer active. Please contact the HR coordinator.",
  ACCOUNT_LOCKED_RESET_ALLOWED_MESSAGE:
    "Your account has been locked after too many failed attempts. Use 'Reset/Forgot your password?' below - resetting your password will unlock your account.",
  ACCOUNT_ADMIN_LOCKED_MESSAGE:
    "Your account has been locked by an administrator. Resetting your password will not unlock it. Please contact your administrator.",
  ATTEMPTS_REMAINING_MESSAGE:
    "You have {number} attempts remaining before your account is temporarily locked.",
  FINGERPRINT_ERROR_MESSAGES: "Error getting device fingerprint",
  TFA_HEADER_MESSAGES:
    "2- Step verification has been enabled for this account. Please enter the one-time code you see on your authenticator app linked.",
  AZURE_ACCOUNT_NOTFOUND_MESSAGE:
    "Sorry this Email ID/Phone does not exist, please contact HR Coordinator.",
  TFA_SETUP_DONE: "Two-factor setup complete. Use your app to log in.",
  TFA_REQUIRED_MESSAGE: "Enter the 6-digit OTP generated by the authenticator app.",
  AZURE_LOGIN_ERROR_MESSAGES:
    "We're having trouble connecting with your Microsoft account right now. Please try again in a few moments.",
  ROLE_NOT_ASSIGNED: "At the moment, you are not active. Please reach out to HR.",
  SSO_LOGGING: "Logging you in via SSO...",
  AUTH_APP_NOT_CONFIGURED: "The Authenticator app is not yet configured",
  AUTH_APP_SETUP: "Authenticator App Setup",
  LOST_ACCESS_AUTH_APP: "Lost access to your Authenticator app?",
  NEW_PASSWORD_ALERT:
    "Your new password must be different from your current and previous passwords.",
  ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT :"This email/phone is linked to an existing account. Please sign in using your primary email/phone",  
  ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT_FORGOTPASSWORD :"This email/phone is linked to an existing account. Please enter your primary email/phone.",  
  NOMATCH_PASSWORD_ALERT:
    "The entered password does not match the current password.",
  PERSONALINFO_FAILED_ALERT:
    "Failed to save personal info",
  NOTIFICATIONS_SAVED_ALERT:
    "Notification preferences saved successfully.",
  NOTIFICATION_FAILED_ALERT:
    "Failed to save notification preferences.",
  INACTIVITY_LOGOUT: "You have been logged out due to inactivity."  
};

export const SIGNALRMESSAGES = {
  CONNECTION_STARTED: "SignalR connection started.",
  CONNECTION_STOPPED: "SignalR connection stopped.",
  CONNECTION_ERROR: "Error starting SignalR connection:",
  ERROR_START_CONNECTION: "Cannot start connection — current state:",
  ERROR_STOPPING_CONNECTION: "Error stopping SignalR connection:",
};

export const DragMessages = {
  DragToMove: `Drag to move to another folder`,
  DragToMoveDisabled: `You don't have permission to move`,
  InvalidDropTarget: `Oops! You can only drop files into folders.`,
};

export const MANAGESETTING_TOOLTIPMESSAGES = {
  ROLLBACK: "Rollback to the previous value",
};


export const USER_PROFILE_TEXT = {
  ACCOUNT_SETTINGS: {
    SMS_RECOVERY_TITLE: "SMS Recovery",
    SMS_RECOVERY_DESC: "SMS are sent to 92838488xx in case of recovery",
  },

  NOTIFICATION_TAB: {
    TITLE: "Notifications",
    PREF_TITLE: "Notification Preferences",
    PREF_DESC:
      "Manage how you receive updates and alerts. You can enable or disable notifications sent through email, SMS or in-app messages, based on what suits you best.",
  },

  NOTIFICATIONS: {
    NEW_MAILS: {
      LABEL: "E-Mails",
      DESC: "Receive important alerts, updates via emails. You can enable or disable these notifications based on your preference.",
    },
    SMS: {
      LABEL: "SMS",
      DESC: "Receive important alerts, updates. You can enable or disable these notifications based on your preference.",
    },
    IN_APP: {
      LABEL: "In-App",
      DESC: "Get quick alerts and updates directly inside the application. These notifications help you stay informed while you're actively using the app",
    },
    MAIL_CHAT: {  
      LABEL: "Mail Chat Messages",
      DESC: "Any of new messages are received will be updated through notifications.",
    },
  },
};
